import { ref, type Ref } from 'vue';
import type { SearchFieldKey } from './types';

export interface SearchFieldControl {
  close: () => void;
}

export type SearchFieldRefs = Record<SearchFieldKey, Ref<SearchFieldControl | null>>;

export interface UseActiveField {
  activeField: Ref<SearchFieldKey | null>;
  closeActiveField: () => void;
  onFieldOpenChange: (field: SearchFieldKey, isOpened: boolean) => void;
}

export function useActiveField(fieldRefs: SearchFieldRefs): UseActiveField {
  const activeField = ref<SearchFieldKey | null>(null);

  function closeActiveField(): void {
    const field = activeField.value;
    if (!field) {
      return;
    }
    activeField.value = null;
    fieldRefs[field].value?.close();
  }

  // Активным становится новое поле до закрытия прежнего: его open-change(false) тогда уже не сбросит карточку.
  function openField(field: SearchFieldKey): void {
    const previousField = activeField.value;
    activeField.value = field;
    if (!previousField || previousField === field) {
      return;
    }
    fieldRefs[previousField].value?.close();
  }

  function onFieldOpenChange(field: SearchFieldKey, isOpened: boolean): void {
    if (isOpened) {
      openField(field);
      return;
    }
    if (activeField.value === field) {
      activeField.value = null;
    }
  }

  return { activeField, closeActiveField, onFieldOpenChange };
}
